import { PersonalDetailsFormConfig } from '../../models/personal-details/personal-details-form-config.interface';
import { mockCmsPersonalDetailsForm } from '../cms/cms-personal-details-form.mock';
import { mockPersonalDetailsFormValue } from './personal-details-form-value.mock';

export const mockPersonalDetailsFormConfig: PersonalDetailsFormConfig = {
  cmsData: mockCmsPersonalDetailsForm,
  initialValue: mockPersonalDetailsFormValue,
};
